const MM_PER_INCH = 25.4;
const MIN_DOTS_PER_MM = 100 / MM_PER_INCH; // 100 dpi minimum
const DPI_WARNING_AT = 100;

export const limitTransform = (exif, transform, scale, momentWidth, momentHeight, newDragged = null, newZoom = 0) => {
  const imageOriginalWidth = exif.width || exif.PixelXDimension;
  const imageOriginalHeight = exif.height || exif.PixelYDimension;

  const totalPx = imageOriginalWidth / transform.width;
  const areaMM = momentWidth / scale;

  const dpi = (totalPx / areaMM) * MM_PER_INCH;

  let newTransform = {
    ...transform,
    dpi,
    lowDpi: dpi < DPI_WARNING_AT,
  };

  const ratio = exif.ratio || imageOriginalHeight / imageOriginalWidth;
  const momentRatio = momentHeight / momentWidth;

  const zoom = transform.width + newZoom;
  const maxLimitZoom = imageOriginalWidth / (momentWidth / scale) / MIN_DOTS_PER_MM;

  const minZoomLimit =
    ratio < momentRatio
      ? momentHeight / ratio / momentWidth // Landscape
      : 1; // Portrait

  // Keep zoom in range
  newTransform.width = Math.max(minZoomLimit, Math.min(zoom, maxLimitZoom));

  let imageWidth = momentWidth * newTransform.width;
  let imageHeight = imageWidth * ratio;

  const [x = 0, y = 0] = newDragged || [];
  const { x: transformX = 0, y: transformY = 0 } = transform;

  // Calculate image size based on new zoom
  if (newZoom) {
    imageWidth = momentWidth * newTransform.width;
    imageHeight = imageWidth * ratio;
  }

  // Y
  const draggedY = y / imageHeight + transformY;
  const minDiffY = imageHeight / 2 - momentHeight / 2;
  const minLimitOffsetY = minDiffY / imageHeight;
  const maxDiffY = momentHeight / 2 - imageHeight / 2;
  const maxLimitOffsetY = maxDiffY / imageHeight;

  // X
  const draggedX = x / imageWidth + transformX;
  const minDiffX = imageWidth / 2 - momentWidth / 2;
  const minLimitOffsetX = minDiffX / imageWidth;
  const maxDiffX = momentWidth / 2 - imageWidth / 2;
  const maxLimitOffsetX = maxDiffX / imageWidth;

  // Keep transform in range
  newTransform.x = draggedX ? Math.max(Math.min(draggedX, minLimitOffsetX), maxLimitOffsetX) : 0;
  newTransform.y = draggedY ? Math.max(Math.min(draggedY, minLimitOffsetY), maxLimitOffsetY) : 0;

  return newTransform;
};

export const getRotationFromOrientation = orientation => {
  switch (orientation) {
    case 'left-bottom':
    case 'left-top':
      return -90;
    case 'right-top':
    case 'right-bottom':
      return 90;
    case 'bottom-right':
    case 'bottom-left':
      return 180;
  }

  return 0;
};

export const getFlipFromOrientation = orientation => {
  switch (orientation) {
    case 'top-right':
    case 'bottom-left':
    case 'left-top':
    case 'right-bottom':
      return 1;
  }

  return 0;
};



// WEBPACK FOOTER //
// ./app/helpers/photo.js